import React from 'react'
import NotFound from '../components/NotFound'

export const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-sp-screen pc:min-h-pc-screen flex justify-center items-center">
      <NotFound />
    </div>
  )
}
